<div 
  class="border rounded p-3" 
  [style.min-height]="minHeight()" 
  [style.max-height]="maxHeight()" 
  [style.overflow-y]="'auto'"
  [class.pointer-events-none]="disabled()" 
  [class.opacity-50]="disabled()">
  <p-tree
    [value]="locationTree()"
    [selection]="selectedLocationNode()"
    selectionMode="single"
    (selectionChange)="onLocationSelectionChange($event)"
    (onNodeSelect)="onLocationTreeNodeSelect($event)"
    (onNodeExpand)="onNodeExpand($event)"
    (onNodeCollapse)="onNodeCollapse($event)"
    [class]="'w-full'">
    <ng-template let-node #node>
      <div class="flex items-center gap-2">
        <span 
          [class.font-bold]="node.key === currentLocationId()" 
          [class.text-primary]="node.key === currentLocationId()">
          {{ node.label }}
        </span>
        <span 
          *ngIf="node.key === currentLocationId()" 
          class="text-xs text-primary ml-2">
          (Current)
        </span>
      </div>
    </ng-template>
  </p-tree>
</div>
